import { useState, useEffect, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import {
  onUpdateUser,
  onResetPassword,
  onGetListLocation
} from "../../../../../Api/AppBackend/User";
import "./input.css";
import Loader from "react-loaders";
import { message, Select} from "antd";

const UpdateUserModal = ({
  editModal,
  setEditModal,
  curObj,
  onGetListUser,
  setLoading,
  t,
  loading
}) => {
  const [listLocation, setListLocation] = useState([]);
  const locationIDInputRef = useRef(null);
  const [formData, setFormData] = useState({
    userID: "",
    password: "",
    confirmPassword: "",
    userName: "",
    address: "",
    typeUser: "",
    objectID: "",
    locationID: "",
    sex: "",
    phone: "",
  });
  const toggleModal = () => setEditModal(!editModal);

  const onHandleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "typeUser" ? parseInt(value, 10) : value,
    }));
  };

  const handleLocationChange = (value) => {
    setFormData({
      ...formData,
      locationID: value,
    });
  };

  const convertTypeUserReverse = (typeUser) => {
    switch (typeUser) {
      case t("Admin"):
        return 1;
      case t("Object"):
        return 2;
      case t("Test Request Location"):
        return 3;
      case t("Patient"):
        return 4;
      default:
        return "";
    }
  };
  
  const convertSexReverse = (sex) => {
    switch (sex) {
      case t("Male"):
        return "M";
      case t("Female"):
        return "F";
      default:
        return "";
    }
  };

  const onHandleUpdate = async (data) => {
    try {
      const id = formData.userID;
      let {
        userName,
        address,
        sex,
        phone,
        typeUser,
        objectID,
        locationID,
        password,
        confirmPassword,
      } = data;
      if (sex !== "M" && sex !== "F") {
        message.error(t("Invalid gender. Gender must be Male or Female"));
        return;
      }
      const res = await onUpdateUser(id, {
        userID: id,
        userName,
        address,
        sex,
        phone,
        typeUser: parseInt(typeUser, 10),
        objectID,
        locationID,
      });
      if (res && res.data && res.data.isSuccess) {
        if (password) {
          if (password !== confirmPassword) {
            message.error(t("Password and confirm password do not match!"));
            return;
          }
          const passwordRes = await onResetPassword({
            userID: id,
            passwordNew: password,
          });

          if (
            !passwordRes ||
            !passwordRes.data ||
            !passwordRes.data.isSuccess
          ) {
            message.error(t("Password update failed"));
            return;
          }
        }
        onGetListUser();
        setEditModal(false);
        message.success(t("User update successful"));
      } else {
        message.error(t("User update failed"));
      }
    } catch (err) {
      message.error(t("An error occurred:") + err.message);
    }
  };

  const onHandleSubmit = () => {
    onHandleUpdate(formData);
  };

  const onGetListLocationBase = () => {
    let listSelect = [
      {
        labelName: (t("Enter test request location code")),
        label: (t("Enter test request location code")),
        value: "",
      },
    ];
    onGetListLocation()
      .then((res) => {
        res.data.data.forEach((s) =>
          listSelect.push({
            labelName: s.locationName != null ? s.locationName : "",
            label:
              s.locationID.trim() +
              (s.locationName != null ? " - " + s.locationName?.trim() : ""),
            value: s.locationID.trim(),
          })
        );
      })
      .catch((err) => {});
    setListLocation(listSelect);
  };

  useEffect(() => {
    console.log("Current Object:", curObj);
    if (curObj) {
      setFormData({
        userID: curObj.userID || "",
        password: "",
        confirmPassword: "",
        userName: curObj.userName || "",
        address: curObj.address || "",
        typeUser: convertTypeUserReverse(curObj.typeUser) || "",
        objectID: curObj.objectID || "",
        locationID: curObj.locationID || "",
        sex: convertSexReverse(curObj.sex) || "",
        phone: curObj.phone || "",
      });
    }
  }, [curObj, editModal]);

  useEffect(()=>{
    onGetListLocationBase()
  }, []);

  return (
    <Modal isOpen={editModal} toggle={toggleModal} className="custom-modal">
      <ModalHeader toggle={toggleModal} className="modal-header-custom">
        {t("Update user information")}
      </ModalHeader>
      <ModalBody className="modal-body-custom">
        <Form>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="userID">{t("Username")}</Label>
                <Input
                  type="text"
                  name="userID"
                  id="userID"
                  placeholder={t("Enter the username")}
                  value={formData.userID}
                  onChange={onHandleInputChange}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="password">{t("Password")}</Label>
                <Input
                  type="password"
                  name="password"
                  id="password"
                  placeholder={t("Enter the your password")}
                  value={formData.password}
                  onChange={onHandleInputChange}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="confirmPassword">{t("Confirm password")}</Label>
                <Input
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder={t("Enter the confirmed password")}
                  value={formData.confirmPassword}
                  onChange={onHandleInputChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="userName">{t("Full name")}</Label>
                <Input
                  type="text"
                  name="userName"
                  id="userName"
                  placeholder={t("Enter the full name")}
                  value={formData.userName}
                  onChange={onHandleInputChange}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="address">{t("Address")}</Label>
                <Input
                  type="text"
                  name="address"
                  id="address"
                  placeholder={t("Enter the address")}
                  value={formData.address}
                  onChange={onHandleInputChange}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="typeUser">{t("Account type")}</Label>
                <Input
                  type="select"
                  name="typeUser"
                  id="typeUser"
                  value={formData.typeUser}
                  onChange={onHandleInputChange}
                >
                  {/* <option value="">{t('Select an account type')}</option> */}
                  <option value="1">{t("Admin")}</option>
                  <option value="2">{t("Object")}</option>
                  <option value="3">{t("Test request location")}</option>
                  <option value="4">{t("Patient")}</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="sex">{t("Gender")}</Label>
                <Input
                  type="select"
                  name="sex"
                  id="sex"
                  value={formData.sex}
                  onChange={onHandleInputChange}
                >
                  {/* <option value="">Chọn giới tính</option> */}
                  <option value="M">{t("Male")}</option>
                  <option value="F">{t("Female")}</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="phone">{t("Phone number")}</Label>
                <Input
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder={t("Enter the phone number")}
                  value={formData.phone}
                  onChange={onHandleInputChange}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              {formData.typeUser === 2 && (
                <FormGroup>
                  <Label for="objectID">{t("Object code")}</Label>
                  <Input
                    type="text"
                    name="objectID"
                    id="objectID"
                    value={formData.objectID}
                    onChange={onHandleInputChange}
                    placeholder={t("Enter object code")}
                  />
                </FormGroup>
              )}
              {formData.typeUser === 3 && (
                <FormGroup>
                  <Label for="locationID">
                    {t("Test request location code")}
                  </Label>
                  <Select
                    showSearch
                    allowClear
                    options={listLocation}
                    value={formData.locationID}
                    style={{ 
                      width: "100%",
                      height: "calc(1.5em + 0.75rem + 3px)" 
                    }}
                    optionFilterProp="label"
                    ref={locationIDInputRef}
                    //onKeyDown={(e) => handleKeyDown(e, "locationID")}
                    onChange={handleLocationChange}
                  />
                </FormGroup>
              )}
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          style={{
            color: "#fff",
            backgroundColor: "#d92550",
            borderColor: "#d92550",
          }}
          onClick={toggleModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="18"
            width="18"
            viewBox="0 0 512 512"
            className="mr-1"
            style={{ marginBottom: 3 }}
          >
            <path
              fill="white"
              d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
            />
          </svg>
          {t("Close")}
        </Button>
        <Button
          style={{
            color: "#fff",
            backgroundColor: "#3ac47d",
            borderColor: "#3ac47d",
          }}
          onClick={onHandleSubmit}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="16"
            viewBox="0 0 512 512"
            className="mr-1"
            style={{ marginBottom: 3 }}
          >
            <path
              fill="white"
              d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
            />
          </svg>
          {t("Save")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateUserModal;
